/**
 * FT3-UA: the ECL settings editor (FSD 2.2.3, design C3 §6.5).
 *
 * A per-feature route file; the INT packet spreads `AR_ECL_SETTINGS_ROUTES`
 * into the router and adds the nav item. `ar.ecl.read` opens the screen;
 * editing is gated inside it on `ar.ecl.manage`.
 */

import type { RouteRecordRaw } from 'vue-router'

import { AR_PERMISSIONS } from '@/modules/ar/permissions'

export const AR_ECL_SETTINGS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/ar/ecl/settings',
    name: 'ar-ecl-settings',
    component: () => import('@/modules/ar/ecl/EclSettingsView.vue'),
    meta: { titleKey: 'ar.routeTitles.eclSettings', permission: AR_PERMISSIONS.eclRead },
  },
]
